export default __webpack_public_path__ + "static/media/logo_white.18d0f67f.svg";